import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import * as defaultStyles from "./WastePickupSearchResults.module.css";
import WastePickupSearchResultsItem from "./WastePickupSearchResultsItem";

WastePickupSearchResults.propTypes = {
  styles: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  searchResults: PropTypes.arrayOf(
    PropTypes.shape({
      buildingId: PropTypes.string,
      buildingAddress: PropTypes.string,
    }),
  ),
};

export default function WastePickupSearchResults({
  styles = defaultStyles,
  className,
  searchResults = [],
}) {
  const { t } = useTranslation();
  return (
    <div className={clsx(styles.component, className)}>
      {searchResults.length > 0 ? (
        <ul className={clsx(styles.list, className)}>
          {searchResults.map((result, index) => (
            <WastePickupSearchResultsItem
              className={clsx(styles.item)}
              key={index}
              {...result}
            />
          ))}
        </ul>
      ) : (
        <div className={clsx(styles.empty)}>
          <p>{t("noSearchResults")}</p>
        </div>
      )}
    </div>
  );
}
